export default {"src":"/_next/static/media/autosport.3d583b10.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};